import script from "./TableMolecule.vue?vue&type=script&setup=true&lang=ts"
export * from "./TableMolecule.vue?vue&type=script&setup=true&lang=ts"

import "./TableMolecule.css?vue&type=style&index=0&id=0b16db0b&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0b16db0b"]])

export default __exports__